export default __webpack_public_path__ + "static/media/five.3fc9b49e.svg";